export const MonthDaysDeltaMock = {
  data: { peakSupplyFlowDelta: 0.966605950212507, availableSupplyFlowDelta: 50 },
};

export const UiMonthDeltaDataMock = {
  peakProduction: 5,
  flowAvailable: 0,
};
